// extracted by mini-css-extract-plugin
export default {"downloadLink":"NktDmodXBVjfPxUSAAsQ","placeHolderShimmer":"mxVtUs3OjESlyJjt1Ds7"};